<!-- index -->
<template>
  <div id='indexPage'>
    <appHeader :isTop="isTop"></appHeader>
    <div class="app-container">
      <router-view/>
    </div>
    <specialService></specialService>
    <appFooter></appFooter>
    <!-- <rightPopup v-if="$store.getters.isMobile || isShow"></rightPopup> -->
    <BackTop/>
    <OnlineDialog></OnlineDialog>
  </div>
</template>

<script>
import appHeader from '@/layouts/newHeader'
import appFooter from '@/layouts/newFooter'
import rightPopup from '@/layouts/rightPopup'
import specialService from '@/layouts/specialService'
import BackTop from '@/components/backTop/index'
import OnlineDialog from '@/layouts/onlineDialog'

export default {
  data () {
    return {
      isTop: true,
      isShow: false,
      headerWhiteNav: true
    }
  },
  components: { appHeader, appFooter, rightPopup, specialService, BackTop, OnlineDialog },
  created () {

  },
  watch: {
    $route (val) {
      this.setHeaderTop(val)
    }
  },
  mounted () {
    this.setHeaderTop(this.$route)
    const appDom = document.getElementById('app')
    if (this.$store.getters.isPC) {
      let currentTop = appDom.scrollTop
      this.isShow = currentTop > 0
      // window.onscroll =
      // window.onscroll = () => {
      //   console.log('ss', document.scrollingElement.scrollTop)
      //   let top = document.scrollingElement.scrollTop // 触发滚动条，记录数值
      //   this.isShow = (top * document.body.clientWidth / 1920) > 930
      // }
    }
    // let oldTop = 0 // 旧数据，初始为0
    // 将自定义方法绑定到窗口滚动条事件
    let _this = this
    appDom.onscroll = () => {
      let top = appDom.scrollTop // 触发滚动条，记录数值
      this.isTop = this.headerWhiteNav ? false : top <= 0
      if (_this.$store.getters.isPC) {

      }
      _this.isShow = !(((((top * appDom.scrollTop / 1920) < 500) && _this.$store.getters.isPC)))
    }
  },
  methods: {
    /**
     * @Desc header样式类型判断
     * @params {Object} val 当前路由对象
     * */
    setHeaderTop (val) {
      const ignoreList = ['downloadCenter', 'aboutUs', 'newsList', 'newsDetail', 'successInfo']
      this.headerWhiteNav = ignoreList.includes(val.name)
      this.isTop = !this.headerWhiteNav
    }
  }
}
</script>
<style scoped lang='scss'>
#indexPage{
  width: 100%;
  min-width: $main-width;
  margin: 0 auto;
  .app-container {

  }
}
</style>
